// AUTO-GENERATED from `ash_small.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 26867,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 13552830,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 0.5,
        "y": 5
      }
    },
    "branch": {
      "levels": 2,
      "angle": {
        "1": 48,
        "2": 75,
        "3": 60
      },
      "children": {
        "0": 10,
        "1": 3,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.01
      },
      "gnarliness": {
        "0": 0.11,
        "1": 0.09,
        "2": 0.05,
        "3": 0.09
      },
      "length": {
        "0": 23.87,
        "1": 18,
        "2": 5.59,
        "3": 4.6
      },
      "radius": {
        "0": 0.81,
        "1": 0.56,
        "2": 0.76,
        "3": 0.7
      },
      "sections": {
        "0": 12,
        "1": 10,
        "2": 10,
        "3": 10
      },
      "segments": {
        "0": 8,
        "1": 6,
        "2": 4,
        "3": 3
      },
      "start": {
        "1": 0.53,
        "2": 0.33,
        "3": 0
      },
      "taper": {
        "0": 0.7,
        "1": 0.7,
        "2": 0.7,
        "3": 0.7
      },
      "twist": {
        "0": 0.3,
        "1": -0.07,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "ash",
      "billboard": "double",
      "angle": 55,
      "count": 30,
      "start": 0,
      "size": 2.05,
      "sizeVariance": 0.717,
      "tint": 16777215,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
